interface IMeasureOptions {
	[key: string]: { id: string; name: string };
}

export const measuresOptions: IMeasureOptions = {
	real: { id: '35ceafb0-f4cf-4be6-8fbf-5595fa4137a8', name: 'Real (R$)' },
	percentual: { id: '35ceafb0-f4cf-4be6-8fbf-5595fa4137a8', name: 'Percentual % ' },
};
